/* import __COLOCATED_TEMPLATE__ from './cash-app-local-mount.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import 'systemjs';
import { action } from '@ember/object';
import { getOwner } from '@ember/application';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import * as Sentry from '@sentry/browser';
import * as singleSpa from 'single-spa';
import { or } from '@ember/object/computed';
import { inject as service } from '@ember/service';
const LOCALHOST_DEV_PORT = '5173';
const API_PATH = '/sq-local-mfe/api/dashboard-spa-manifest';
let CashAppLocalMount = (_dec = or('mountFailure', 'apiEndpointFailuire'), _class = class CashAppLocalMount extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "parcel", void 0);
    _defineProperty(this, "module", void 0);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "environment", _descriptor2, this);
    _initializerDefineProperty(this, "mountFailure", _descriptor3, this);
    _initializerDefineProperty(this, "apiEndpointFailure", _descriptor4, this);
    _initializerDefineProperty(this, "bundle", _descriptor5, this);
    _initializerDefineProperty(this, "failureMessage", _descriptor6, this);
    _initializerDefineProperty(this, "mountOrApiFailure", _descriptor7, this);
  }
  async setupApp(domElement) {
    try {
      singleSpa.start();
      const response = await fetch(this.endpoint);
      const {
        app
      } = await response.json();
      this.module = await System.import(`${app.cdnOrigin}/${app.main}`);
      const {
        bootstrap,
        mount,
        unmount,
        update
      } = this.module;
      const parcelConfig = {
        bootstrap,
        mount,
        unmount,
        update
      };
      this.parcel = singleSpa.mountRootParcel(parcelConfig, {
        domElement,
        ...this.args.customProps
      });
      await this.parcel.mountPromise;
    } catch (e) {
      this.errorHandler(e);
      this.setMountFailure(e);
    }
  }
  async mountApplication(module, domElement) {
    const parcelConfig = {
      bootstrap: module.bootstrap,
      mount: module.mount,
      unmount: module.unmount
    };
    const parcelProps = {
      domElement,
      ...this.customProps
    };
    this.parcel = singleSpa.mountRootParcel(parcelConfig, parcelProps);
    await this.parcel.mountPromise;
  }
  teardownApp() {
    if (this.parcel) {
      this.parcel.unmount().catch(e => Sentry.captureException(e));
    }
  }
  get customProps() {
    return {
      ...this.args.customProps,
      merchantToken: this.userInfo.merchantToken
    };
  }
  get config() {
    return getOwner(this).resolveRegistration('config:environment');
  }
  get useLocalIntegration() {
    return this.config.dashboardMFE?.['sq-local-mfe']?.enabled;
  }
  get endpoint() {
    const {
      isProduction,
      isSandbox,
      isDevelopment
    } = this.environment;
    if (this.useLocalIntegration && isDevelopment) {
      return `http://localhost:${LOCALHOST_DEV_PORT}${API_PATH}`;
    } else if (isProduction || isSandbox) {
      return `https://app.squareup.com${API_PATH}`;
    } else {
      return `https://app.squareupstaging.com${API_PATH}`;
    }
  }
  setMountFailure(error) {
    this.mountFailure = true;
    const {
      isDevelopment,
      isTesting
    } = this.environment;
    if (isDevelopment && !isTesting) {
      this.failureMessage = error.message;
    }
  }
  errorHandler(error) {
    const {
      isDevelopment,
      isTesting
    } = this.environment;
    if (isDevelopment || isTesting) {
      // eslint-disable-next-line no-console
      console.error(error);
      return;
    }
    Sentry.captureException(error);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "environment", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "mountFailure", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "apiEndpointFailure", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "bundle", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.bundle;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "failureMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "mountOrApiFailure", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setupApp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setupApp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "teardownApp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "teardownApp"), _class.prototype), _class);
export { CashAppLocalMount as default };